"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
const choices_js_1 = __importDefault(require("choices.js"));
const mithril_1 = __importDefault(require("mithril"));
const OVERFLOWS = {};
let UUID = 0;
let isForced = false;
function genId(x) {
    let id = x.id;
    if (!id) {
        id = x.id = `__hr_uid__${UUID += 1}`;
    }
    return id;
}
function gettext(elm) {
    if (!elm)
        return "<VIDE>";
    if (!!elm.text)
        return elm.text;
    if (typeof (elm.children) == "string")
        return elm.children;
    return (gettext(elm.children[0]));
}
function forceReapplyOverflow() {
    for (const key in OVERFLOWS) {
        if (OVERFLOWS.hasOwnProperty(key)) {
            OVERFLOWS[key]();
        }
    }
}
function forceRemoveOverflow(x) {
    if (!x || !x.style) {
        return;
    }
    const currentOverflow = x.style.overflow;
    const currentMarginTop = x.style.marginTop;
    const id = genId(x);
    OVERFLOWS[genId(x)] = () => {
        const elm = document.getElementById(id);
        if (elm) {
            elm.style.overflow = currentOverflow;
            elm.style.marginTop = currentMarginTop;
        }
    };
    x.style.marginTop = `-${x.scrollTop}px`;
    x.style.overflow = "visible";
    forceRemoveOverflow(x.parentNode);
}
exports.Select = {
    oncreate(node) {
        let elm = node.dom;
        elm.addEventListener("showDropdown", (_x) => {
            if (isForced) {
                forceReapplyOverflow();
            }
            forceRemoveOverflow(_x.target);
            isForced = true;
        });
        elm.addEventListener("hideDropdown", (_x) => {
            forceReapplyOverflow();
            isForced = false;
        });
        node.dom.choices = new choices_js_1.default(node.dom, {
            addItemText: (value) => { return `Presser Entrée pour ajouter <b>"${value}"</b>`; },
            itemSelectText: "",
            maxItemText: (maxItemCount) => { return `Seulement ${maxItemCount} valeur(s) peuvent être ajoutée(s)`; },
            shouldSort: !node.attrs.unsorted,
        });
        this.onupdate(node);
    },
    onremove(node) {
        var _a;
        (_a = node.dom.choices) === null || _a === void 0 ? void 0 : _a.destroy();
    },
    onupdate(node) {
        var _a, _b;
        if ((_b = (_a = node.dom) === null || _a === void 0 ? void 0 : _a.choices) === null || _b === void 0 ? void 0 : _b.initialised) {
            let choices = node.dom.choices;
            if (node.attrs.disabled)
                choices.disable();
            else
                choices.enable();
            // Assuming the children nodes are Options:
            if (node.children instanceof Array) {
                let arr = node.children.map((elm) => {
                    if (elm.tag == "option") {
                        const label = gettext(elm);
                        return {
                            value: elm.attrs.value,
                            label: label,
                            selected: elm.attrs.selected,
                            disabled: elm.attrs.disabled
                        };
                    }
                    else {
                        return;
                    }
                });
                let x = this;
                if (JSON.stringify(arr) != JSON.stringify(x.oldChoice)) {
                    window.CHOICE = choices;
                    choices.setChoices(arr, 'value', 'label', true);
                    x.oldChoice = arr;
                }
            }
        }
    },
    view(node) {
        return (0, mithril_1.default)("select", Object.assign({
            onchange: (evt) => {
                if (node.attrs.oninput) {
                    node.attrs.oninput(evt);
                }
            }
        }, node.attrs));
    }
};
